import { AxiosInstance } from "axios";
import { toast } from "react-toastify";
import { ScoreType } from "../../components/AdminSearchScore";
import { apiURL } from "../../config";

export type GroupType = "decision" | "user";

export async function getScoring(axiosPrivate: AxiosInstance, group: GroupType) {
	return axiosPrivate
		.get(`${apiURL}/admin/boost/config/${group}.json`)
		.then((res) => {
			if (res.status < 300 && res.status > 199) return res.data;
		})
		.catch((err) => {
			return err.response;
		});
}

export async function putScoring(variables: { axiosPrivate: AxiosInstance; group: GroupType; data: ScoreType["boost"] }) {
	const { axiosPrivate, group, data } = variables;
	return axiosPrivate
		.put(`${apiURL}/admin/boost/config/${group}.json`, data)
		.then((res) => {
			if (res.status < 300 && res.status > 199) {
				toast.success("Scoring updated");
				return res.data;
			} else {
				toast.error("Could not update scoring. Please try again.");
			}
		})
		.catch((err) => {
			return err.response;
		});
}
